var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconExternalD = function SvgIconExternalD(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5mm",
    height: "6.13mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14.17 17.39",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3,17.35c-.15,0-.3-.04-.44-.12-.3-.17-.49-.49-.49-.85V1.1C.36.57.78.14,1.3.14h11.54c.52,0,.94.43.94.96v15.28c0,.36-.19.68-.49.85-.3.16-.64.15-.93-.03h0s-5.31-3.38-5.31-3.38l-5.25,3.38c-.15.1-.32.15-.49.15ZM12.88,16.36h0s0,0,0,0ZM7.08,12.83c.17,0,.34.05.49.15l5.23,3.33-.03-15.2-11.48.04.06,15.15,5.23-3.31c.15-.1.32-.14.49-.14Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconExternalD);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-externalD.9c98eb4334d902f195c46e68bbddf2e9.svg";